// extracted by mini-css-extract-plugin
module.exports = {"root":"manageFAQ_root__7EjpG","uploadFileButton":"manageFAQ_uploadFileButton__1NkPa","alignToRight":"manageFAQ_alignToRight__2CPzY","jsonExample":"manageFAQ_jsonExample__1g1KG"};